import { render, staticRenderFns } from "./status-tab.component.vue?vue&type=template&id=df29024e&scoped=true&"
import script from "./status-tab.component.vue?vue&type=script&lang=ts&"
export * from "./status-tab.component.vue?vue&type=script&lang=ts&"
import style0 from "./status-tab.component.vue?vue&type=style&index=0&id=df29024e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df29024e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VTab,VTabItem,VTabs})
